import React from "react";
import styles from "./loading-indicator-card.module.scss";
import SkeletonLoader from "@/components/layout/skeleton-loader/skeleton-loader";

const LoadingIndicatorCard = () => {
  return (
    <div className={styles.delegateCard}>
      <SkeletonLoader />
    </div>
  );
};

export default LoadingIndicatorCard;
